import React, {useContext, useEffect, useState} from 'react';
import Flag from 'react-world-flags'
import {LangContext} from "../App";
import {axios} from "../axios";
import {Link} from "react-router-dom";
import Seo from "../components/Seo/Seo";

const EmbassyPage = () => {
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/embassy`)
            .then(res => setData(res.data.tours || []))
            .catch(err => {
                console.error('Error fetching embassies:', err);
                setData([]);
            });

    },[lang])
    return (
        <div className='embassy'>
            <Seo pageKey="embassies" />
            <div className="center-wrapper">
                <div className="embassy-list">
                    {data.map(e => {
                        return (
                            <Link key={e.id} to={`/embassy-page/${e.id}`} className="embassy-item">
                                <div className="d-flex">
                                    <Flag code={e.country} />
                                    <Flag code="arm" />
                                </div>
                                <h2>{e.title}</h2>
                            </Link>
                        )
                    })}

                </div>
            </div>
        </div>
    );
};

export default EmbassyPage;